export const Settings_icon = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30 37.5C34.1421 37.5 37.5 34.1421 37.5 30C37.5 25.8579 34.1421 22.5 30 22.5C25.8579 22.5 22.5 25.8579 22.5 30C22.5 34.1421 25.8579 37.5 30 37.5Z"
      stroke="white"
      strokeWidth="3.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 32.2001V27.8001C5 25.2001 7.125 23.0501 9.75 23.0501C14.275 23.0501 16.125 19.8501 13.85 15.9251C12.55 13.6751 13.325 10.7501 15.6 9.45009L19.925 6.97509C21.9 5.80009 24.45 6.50009 25.625 8.47509L25.9 8.95009C28.15 12.8751 31.85 12.8751 34.125 8.95009L34.4 8.47509C35.575 6.50009 38.125 5.80009 40.1 6.97509L44.425 9.45009C46.7 10.7501 47.475 13.6751 46.175 15.9251C43.9 19.8501 45.75 23.0501 50.275 23.0501C52.875 23.0501 55.025 25.1751 55.025 27.8001V32.2001C55.025 34.8001 52.9 36.9501 50.275 36.9501C45.75 36.9501 43.9 40.1501 46.175 44.0751C47.475 46.3501 46.7 49.2501 44.425 50.5501L40.1 53.0251C38.125 54.2001 35.575 53.5001 34.4 51.5251L34.125 51.0501C31.875 47.1251 28.175 47.1251 25.9 51.0501L25.625 51.5251C24.45 53.5001 21.9 54.2001 19.925 53.0251L15.6 50.5501C13.325 49.2501 12.55 46.3251 13.85 44.0751C16.125 40.1501 14.275 36.9501 9.75 36.9501C7.125 36.9501 5 34.8001 5 32.2001Z"
      stroke="white"
      strokeWidth="3.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);